import React, { Component } from 'react';
import { connect } from "react-redux";
import "./style.scss";

// imports components
import TopNavbar from "../Topnavbar";
import Connexion from "../ConnexionContent";

// import actions
import { getUsers } from "../../actions/users.action";

class ConnectedConnexionPage extends Component {
    componentDidMount() {
        this.props.getUsers();
    }

    render() {
        return (
            <div className="Connexion-container">
                <TopNavbar />
                <Connexion />
            </div>
        );
    }
}

const mdtp = dispatch => ({
    getUsers: () => dispatch(getUsers())
})

export const ConnexionPage = connect(
    null,
    mdtp
)(ConnectedConnexionPage)

export default ConnexionPage;